export const expensesListingRoutes = [
  {
    path: 'listing',
    name: 'expenses-listing',
    component: () => import(/* webpackChunkName: "expenses-listing" */ './ExpensesListing.vue')
  }
];
